import { render, staticRenderFns } from "./exApplyForModification.vue?vue&type=template&id=10830833&scoped=true&"
import script from "./exApplyForModification.vue?vue&type=script&lang=js&"
export * from "./exApplyForModification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10830833",
  null
  
)

export default component.exports